import React from "react";
// import Modal from "./Modal";

export default class LoginFooter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // showModal: false
        };

        // this.toggleModal = this.toggleModal.bind(this);
    }
    // No longer needed as we are hard-coding the links
    /* toggleModal(content) {
        //TODO: Refactor-This is an ugly way to prevent body scrolling when modal is open
        document.body.style.overflow =
            document.body.style.overflow === "hidden" ? "auto" : "hidden";
        this.setState({
            showModal: this.state.showModal ? false : true,
            modalContent: content
        });
    } */
    render() {
        return (
          <div className='login-footer'>
            <span className=''>
              Use of this site is subject to the{' '}
              <a
                href='https://www.synchronycredit.com/essimages/cs/groups/ess_webasset/plcc/@amazon/en/html/019578.html'

                // No longer needed as we are hard-coding the links
                /*  onClick={() =>
                            this.toggleModal(this.props.config.terms)
                        } */
              >
                Online Usage Agreement
              </a>{' '}
              and{' '}
              <a
                href='https://apply.syf.com/cs/groups/public/documents/et_appdoc/e026513.html'
                // No longer needed as we are hard-coding the links
                /* onClick={() =>
                            this.toggleModal(this.props.config.privacy_policy)
                        } */
              >
                Online Privacy Policy
              </a>
            </span>
            <div className='copyright'>
              &copy; {this.props.config.year} Synchrony Bank
            </div>

            {/* {this.state.showModal ? (
              <Modal
                terms={this.state.modalContent}
                analytics={this.props.analytics}
                toggleModal={this.toggleModal}
              />
            ) : null} */}
          </div>
        );
    }
}
